
import { Card, CardContent } from "@/components/ui/card";
import ProfileReviews from "@/components/ProfileReviews";

interface SellerReviewsTabProps {
  sellerId: string;
}

const SellerReviewsTab = ({ sellerId }: SellerReviewsTabProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <ProfileReviews 
          profileId={sellerId}
          reviewType="offer"
          limit={0}
        />
      </CardContent>
    </Card>
  );
};

export default SellerReviewsTab;
